import {Form, Input, Button, Card, Typography, InputNumber, Select, DatePicker} from 'antd';
import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import {useHistory} from "react-router-dom";
import ApiService from "../core/service/ApiService";
import PatientLocalStorage from "./PatientLocalStorage";
import Flex from "../core/components/Flex";
import AddonBefore from "../core/components/AddonBefore";
import {t} from "i18next";
import {parse} from "uuid";
import {isMobile} from "react-device-detect";

export default function PatientLogin()
{
    const {t} = useTranslation();
    const formRef = useRef();
    const history = useHistory();
    const [error, setError] = useState('')
    const [authParams, setAuthParams] = useState({
        enabled: false,
        key: null,
        timeout: 0,
        sms_auth: false,
        mail_auth: false,
    });

    const sendCode = async (type) => {
        setError('')

        const res = await ApiService.Auth.SendCode({
            code_key: authParams.key,
            code_type: type,
            grant_type: 'patient'
        })

        if(res.success) {
            setAuthParams({
                ...authParams,
                enabled: true,
                key: res.data?.access_token,
                timeout: 60,
                sms_auth: authParams.sms_auth,
                mail_auth: authParams.mail_auth,
            })
            startTimer()
        }
    }

    const startTimer = () => {
        const interval = setInterval(() => {
            setAuthParams((prev) => {
                const nextTimeout = prev.timeout-1
                if(nextTimeout === 0) {
                    clearInterval(interval)
                }

                return {
                    ...prev,
                    timeout: prev.timeout-1
                }
            })
        }, 1000)
    }

    const signIn = async (form) => {
        setError('')

        if(!authParams.enabled) {
            const response = await ApiService.Auth.Login({
                username: form.username,
                password: `${form.birthYear}-${parseInt(form.birthMonth)}-${parseInt(form.birthDay)}`,
                grant_type: 'patient'
            })
            if(response.success) {
                if(response.data.sms_auth === false && response.data.mail_auth === false && response.data.access_token) {
                    PatientLocalStorage.saveToken(response.data?.access_token)
                    const res = await ApiService.PatientApp.GetPatient()
                    if(res.success) {
                        PatientLocalStorage.saveInformation(res.data)
                    }
                    redirectToHome()
                    return
                }

                setAuthParams({
                    enabled: true,
                    sms_auth: response.data.sms_auth,
                    mail_auth: response.data.mail_auth,
                    timeout: 0,
                    key: response.data?.access_token,
                    sms_text: response.data.sms_text,
                    mail_text: response.data.mail_text,
                })
            }
            else {
                setError(t('Please check your information!'))
            }
        }
        else {
            const verifyResponse = await ApiService.Auth.SmsVerify({
                password: form.code,
                code_key: authParams.key,
                grant_type: 'patient'
            })

            if(verifyResponse.success) {
                PatientLocalStorage.saveToken(verifyResponse.data?.access_token)
                const res = await ApiService.PatientApp.GetPatient()
                if(res.success) {
                    PatientLocalStorage.saveInformation(res.data)
                }
                redirectToHome()
            }
            else {
                setError(t('Verification code is wrong!'))
            }
        }
    }

    const redirectToHome = () => {
        if(PatientLocalStorage.isAuth())
        {
            history.push(`/`)
        }
    }

    useEffect(() => {
        redirectToHome()
    }, [])

    return (
        <>
            <Flex
                flexDirection={'column'}
                alignItems={'center'}
                style={{
                    height: '100%',
                    backgroundColor: '#edf2f8',
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${window?.AppSettings?.theme?.background?.path})`,
                }}
            >
                <img src={window.AppSettings.theme.logo.path} width={300} style={{marginTop: 64, marginBottom: 64}}/>
                <Card title={t('Login')}>
                    <Form
                        style={{width: 320}}
                        ref={formRef}
                        name="basic"
                        layout={'vertical'}
                        initialValues={{}}
                        autoComplete="off"
                        onFinish={signIn}
                    >
                        <Form.Item
                            label={t('Identity Number')}
                            name="username"
                            rules={[{required: true, message: t('Please input your identity number!')}]}
                        >
                            <Input
                                size={'large'}
                                disabled={authParams.enabled}/>
                        </Form.Item>

                        {
                            !authParams.enabled && (
                                <div>
                                    <Typography.Text>
                                        {t('Birth Date') + ': '} <span style={{color: '#808080'}}>({t('DD/MM/YYYY')})</span>
                                    </Typography.Text>
                                    <div style={{display: 'flex', alignItems: 'center', width: '100%', flexWrap: 'wrap'}}>
                                        <Form.Item
                                            style={{flex: 1}}
                                            name={'birthDay'}
                                            required={true}
                                            rules={[{required: true, message: t('Please input your birth date!')}]}
                                        >
                                            <InputNumber
                                                size={'large'}
                                                style={{minWidth: 80}}
                                                placeholder={'1'}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{flex: 1}}
                                            name={'birthMonth'}
                                            required={false}
                                            rules={[{required: true, message: t('Please input your birth date!')}]}
                                        >
                                            <InputNumber
                                                size={'large'}
                                                style={{minWidth: 80}}
                                                placeholder={'1'}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            style={{flex: 1}}
                                            name={'birthYear'}
                                            required={false}
                                            rules={[{required: true, message: t('Please input your birth date!')}]}
                                        >
                                            <InputNumber
                                                size={'large'}
                                                style={{minWidth: 80}}
                                                placeholder={'1990'}
                                            />
                                        </Form.Item>
                                    </div>
                                </div>
                            )
                        }

                        {
                            authParams.enabled && (
                                <>
                                    <Form.Item
                                        label={' '}
                                        colon={false}
                                    >
                                        <div style={{width: '100%', wordWrap: 'break-word', wordBreak: 'break-word'}}>
                                            {t('You need to verify the security code to log in to your account.')}
                                        </div>
                                        <div style={{marginTop: 8}}>
                                            {
                                                authParams.sms_auth && (
                                                    <Button
                                                        size={'large'}
                                                        style={{width: '100%', height: 45}}
                                                        disabled={authParams.timeout > 0}
                                                        onClick={() => {
                                                            sendCode('sms')
                                                        }}
                                                    >
                                                        {t('SMS') + ` (*** *** **${authParams.sms_text})`}
                                                    </Button>
                                                )
                                            }
                                            {
                                                authParams.mail_auth && (
                                                    <Button
                                                        size={'large'}
                                                        style={{width: '100%', height: 45}}
                                                        disabled={authParams.timeout > 0}
                                                        onClick={() => {
                                                            sendCode('mail')
                                                        }}
                                                    >
                                                        {t('Mail') + ` (${authParams.mail_text})`}
                                                    </Button>
                                                )
                                            }
                                        </div>
                                    </Form.Item>
                                    {
                                        authParams.timeout > 0 && (
                                            <Form.Item
                                                label={t('Code')}
                                                name="code"
                                                rules={[{required: true, message: t('Please input your verification code!') }]}
                                            >
                                                <Input
                                                    size={'large'}
                                                    // type={'hidden'}
                                                    addonAfter={(
                                                        <div>
                                                            {authParams.timeout > 0 && ` (${authParams.timeout})`}
                                                        </div>
                                                    )}
                                                />
                                            </Form.Item>
                                        )
                                    }
                                </>
                            )
                        }

                        <Typography.Text style={{color: '#ff0000', fontWeight: 'bold', marginBottom: 16, fontSize: '11pt'}}>
                            {t(error)}
                        </Typography.Text>

                        <Form.Item>
                            <Button type="primary" htmlType="submit" style={{width: '100%', height: 48, fontSize: '16pt'}}>
                                {
                                    !authParams.enabled ? t('Login') : t('Send')
                                }
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </Flex>
        </>
    )
}
